import { useTranslation } from 'react-i18next'

import FormSection from '../../../../../components/formSection/FormSection'

import type { AddressModel } from '../../../../../types/court/court'
import { formatAddress } from '../../../../../utils/address/address'

type GuestPaymentStepProps = {
  email: string
  address: AddressModel
  includeAccount: boolean
}

const GuestPaymentStep = ({
  email,
  address,
  includeAccount,
}: GuestPaymentStepProps) => {
  const { t } = useTranslation(['bookings', 'address'])

  return (
    <FormSection
      title={t('booking.guest-checkout.payment.title')}
      subtitle={t('booking.guest-checkout.payment.subtitle')}
    >
      <div className="guest-checkout-payment-review">
        <div className="guest-checkout-payment-row">
          <span>{t('booking.guest-checkout.payment.contact')}</span>
          <strong>{email.trim()}</strong>
        </div>
        <div className="guest-checkout-payment-row">
          <span>{t('booking.guest-checkout.payment.billing-address')}</span>
          <strong>
            {formatAddress(address, {
              number: t('address:number'),
              floor: t('address:floor'),
              apartment: t('address:apartment'),
            })}
          </strong>
        </div>
        <div className="guest-checkout-payment-row">
          <span>{t('booking.guest-checkout.payment.checkout-type')}</span>
          <strong>
            {t(
              includeAccount
                ? 'booking.guest-checkout.payment.with-account'
                : 'booking.guest-checkout.payment.without-account'
            )}
          </strong>
        </div>
      </div>
    </FormSection>
  )
}

export default GuestPaymentStep
